
































import Vue from 'vue'

import { SingleActions } from '@/shared/Actions'
import { IRoom } from '@/models/IRoom'
import { API_URL } from '@/shared/config/consts'

import Spinner from '@/components/Spinner.vue'
import RoomAdminCard from '@/components/admin/RoomAdminCard.vue'
import { connections } from '@/shared/socketApi'

export default Vue.extend({
  name: 'RegistrationLiveView',
  components: {
    Spinner,
    RoomAdminCard
  },
  computed: {
    rooms(): Array<IRoom> {
      return this.$store.state.rooms
    },
    duplicatedStudents(): string[] {
      return this.$store.getters.duplicatedStudents.map(
        (it: any) => `${it.name} ${it.surname} (${it.appearsIn.map((room: any) => room.name).join(', ')})`
      )
    },
    totalPlacesPercentage(): number {
      const totalStudents = this.$store.state.rooms
        .map((room: IRoom) => room.students.length)
        .reduce((count: number, acc: number) => acc + count, 0)

      const totalSize = this.$store.state.rooms
        .map((room: IRoom) => room.size)
        .reduce((count: number, acc: number) => acc + count, 0)

      return Math.round((totalStudents / totalSize) * 100) || 0
    }
  },
  mounted() {
    this.$store.dispatch(SingleActions.FETCH_ALL_ROOMS)
    connections.roomUpdates.open()
    connections.clientsUpdates.open()
  },
  beforeDestroy() {
    connections.roomUpdates.close()
    connections.clientsUpdates.close()
  },
  methods: {
    exportToExcel() {
      const link = document.createElement('a')
      link.setAttribute('href', API_URL + '/api/v1/rooms/export')
      link.setAttribute('download', `${this.$t('pokoje')}.xlsx`)
      link.click()
    }
  }
})
